export default [

  {
    key: 'name',
    label: 'field.name',
    rules: 'required',
    type: 'text',
    cols: 12,
  },
  {
    key: 'task',
    label: 'field.abilities',
    rules: 'required',
    type: 'text-area',
    rows: '2',
    cols: 12,
  },
  {
    key: 'parameters',
    label: 'field.parameters',
    rules: 'required',
    type: 'tags',
    hint: 'placeholder.newRequiredParameters',
    cols: 12,
  },
  {
    key: 'enabledServiceSystem',
    label: 'field.enabledServiceSystem',
    rules: 'required',
    type: 'radio',
    cols: 12,
    options: [
      { text: 'field.enabled', value: true },
      { text: 'field.disabled', value: false },
    ],
  },
  {
    key: 'hookUrl',
    label: 'field.hookUrl',
    rules: 'required',
    type: 'text',
    cols: 12,
  },
  {
    key: 'apiKey',
    label: 'field.apiKey',
    rules: 'required',
    type: 'text',
    cols: 12,
  },
]
